import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { errorHandler } from "../../../util/errorHandler";
import PayApi from "../../../api/pay.api";
import moment from "moment";

const RefundDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  // mounted
  useEffect(() => {
    getRefundInfo();
  }, []);

  // ----- 정보 가져오기
  const [refundInfo, setRefundInfo] = useState({});

  const getRefundInfo = async () => {
    try {
      const response = (await PayApi.getById(id)).data.data.content;
      setRefundInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>

          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>취소/환불상태</DetailFormTitle>
                <DetailFormText>
                  {refundInfo.paymentStatus == "REFUND_REQUEST"
                    ? "환불요청"
                    : "환불완료"}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제일자</DetailFormTitle>
                <DetailFormText>{moment(refundInfo.createdAt).format("YYYY/MM/DD HH:mm:ss")}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제수단</DetailFormTitle>
                <DetailFormText>{refundInfo.payMethod}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>요청일자</DetailFormTitle>
                <DetailFormText>{moment(refundInfo.refundRequestDate).format("YYYY/MM/DD HH:mm:ss")}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>취소일자</DetailFormTitle>
                <DetailFormText>{refundInfo.refundCompleteDate ? moment(refundInfo.refundCompleteDate).format("YYYY/MM/DD HH:mm:ss") : ""}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>구매자 정보</DetailFormTitle>
                <div>
                  <DetailFormText>{refundInfo.name}</DetailFormText>
                  <DetailFormText>{refundInfo.phoneNumber}</DetailFormText>
                  <DetailFormText>{refundInfo.email}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강의명</DetailFormTitle>
                <DetailFormText>{refundInfo.lectureTitle}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>쿠폰</DetailFormTitle>
                <DetailFormText>-{refundInfo.couponPay?.toLocaleString()}원</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제금액</DetailFormTitle>
                <DetailFormText>{refundInfo.realPay?.toLocaleString()}원</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>환불금액</DetailFormTitle>
                <DetailFormText>{refundInfo.realPay?.toLocaleString()}원</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>쿠폰 반환</DetailFormTitle>
                <DetailFormText>{refundInfo.couponPay?.toLocaleString()}원</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default RefundDetail;
